import { ProductState } from '@tcr-erp/shared';
import type { ProductListQuery } from '@/services/queryKeys';

export type ProductFilterValue = Omit<ProductListQuery, 'page' | 'page_size'>;

/** Nguồn sự thật duy nhất cho trạng thái filter ban đầu và cho nút "Xoá tất cả". */
export const DEFAULT_PRODUCT_FILTER: ProductFilterValue = {
  state: [ProductState.ACTIVE, ProductState.DRAFT],
};

const DEFAULT_STATE_SET = new Set<number>(DEFAULT_PRODUCT_FILTER.state ?? []);

/**
 * So khớp theo tập hợp — thứ tự người dùng chọn không tính là thay đổi.
 * Một state bị xoá sạch (`undefined` hoặc `[]`) KHÔNG được coi là mặc định:
 * query gửi lên server khi đó không có tham số `state`, trả về kết quả khác
 * với mặc định (bao gồm cả sản phẩm INACTIVE/ẩn).
 */
function isDefaultState(state: number[] | undefined): boolean {
  if (!state || state.length === 0) return false;
  const stateSet = new Set(state);
  if (stateSet.size !== DEFAULT_STATE_SET.size) return false;
  return Array.from(stateSet).every((s) => DEFAULT_STATE_SET.has(s));
}

export function hasActiveFilter(value: ProductFilterValue): boolean {
  if ((value.q ?? '').trim().length > 0) return true;
  if ((value.category_id?.length ?? 0) > 0) return true;
  if ((value.brand_id?.length ?? 0) > 0) return true;
  if ((value.sale_type?.length ?? 0) > 0) return true;
  if (value.sort !== undefined) return true;
  if (Object.keys(value.attrs ?? {}).length > 0) return true;
  return !isDefaultState(value.state);
}
